












































































































import { cloneDeep, merge } from 'lodash'
import moment from 'moment'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import ModelSetter from '../../../../../../Mixins/ModelSetter'
import { errorNotificationWrapper } from '../../../../../../logic/helpers/NotificationService'
import ConfigField from '../../../../../ConfigField/ConfigField.vue'
import { UseFields } from '../../../../../Pi'
import CustomEditor from '../../../logic/Editor/CustomEditor'
import { EditorViewMode, FlowStatisticsMode, FlowStatValueType } from '../../../logic/Editor/types'
import { FlowStatistics } from '../../../logic/FlowStatistics'

@Component({
  components: {
    ConfigField
  },
  data() {
    return {
      FlowStatisticsMode
    }
  }
})
export default class FlowStatisticsSettings extends Mixins(UseFields, ModelSetter) {
  @Prop() editor!: CustomEditor

  @Emit()
  closeSettings() {
    return null
  }

  model: null | FlowStatistics['statSetting'] = null;

  criteriaOptions = [
    { label: this.$t('flow_statistics_criteria_users'), value: FlowStatisticsMode.Users },
    { label: this.$t('flow_statistics_criteria_steps'), value: FlowStatisticsMode.Steps },
    { label: this.$t('flow_statistics_criteria_user'), value: FlowStatisticsMode.User },
  ]

  valueTypeOptions = [
    { label: this.$t('flow_statistics_value_type_fixed'), value: FlowStatValueType.Fixed },
    { label: this.$t('flow_statistics_value_type_percent'), value: FlowStatValueType.Percent },
  ]

  isLoading = false

  get datesNotValid() {
    return moment(this.model?.from).isSameOrAfter(this.model?.to)
  }

  get userModeIsNotValid() {
    return this.model?.mode === FlowStatisticsMode.User && !this.model.user?.id
  }

  get acceptDisabled() {
    return this.datesNotValid || this.userModeIsNotValid
  }

  handleClick() {
    this.isLoading = true

    this.editor.statistics?.findUserInfo((this.model!.user.login ?? ''))
      .then((res) => {
        if (res) {
          this.acceptStatSettings();
        } else if (res === null) {
          errorNotificationWrapper(this.$t('error').toString(), this.$t('user_info_get_not_found').toString())
        } else {
          return
        }
      })
      .finally(() => this.isLoading = false)
  }

  acceptStatSettings() {
    if (this.model && this.editor.statistics) {
      const { user, ...fields } = this.model

      merge(this.editor.statistics.statSetting, fields)

      if (!this.editor.isStatisticsViewSelected) {
        this.editor.viewMode = EditorViewMode.Statistics
      }

      this.editor.statistics.getStatisticsBySelectedMode()

      this.closeSettings()
    }
  }

  cancelSettings() {
    this.closeSettings()
  }

  created() {
    if (this.editor.statistics) {
      this.model = cloneDeep(this.editor.statistics.statSetting)
    }
  }
}
